import * as React from 'react';

import UserPopup from 'shared/newContainers/UserPopup';
import { AvatarSize } from 'shared/newEntities/components/user/Avatar';

import PopupContent from './PopupContent';

const User: React.FC = () => {
  return (
    <UserPopup avatarSize={AvatarSize.sm} closeOnDocumentClick={false}>
      {(close) => <PopupContent close={close} />}
    </UserPopup>
  );
};

export default React.memo(User);
